import getWeekDay from "./getWeekDay";
import isCurrentDateInRange from "./isCurrentDateInRange";

/**
 * Возвращает день недели (рус.) если дата входит в диапазон [currentDate, futureDate],
 * иначе возвращает отформатированную дату (dd.mm или dd.mm.yy).
 * @param {Date} currentDate - Начало диапазона.
 * @param {Date} futureDate - Конец диапазона.
 * @param {Date} date - Проверяемая дата.
 * @returns {string} День недели или отформатированная дата.
 */
const getDayStringFromDate = (currentDate, futureDate, date) => (
  isCurrentDateInRange(currentDate, futureDate, date)
    ? getWeekDay(date)
    : date?.toLocaleDateString('ru', {
      day: "2-digit",
      month: "2-digit",
      year: currentDate.getFullYear() === date.getFullYear() ? undefined : "2-digit",
    }));

export default getDayStringFromDate;
